import React, { memo, useEffect, useMemo, useState } from 'react';
import InfoBubble from '@gp/components/InfoBubble';
import classNames from 'classnames';
import SvgIcon from '@/pages/home/components/SvgIcon';
import './index.scss';

interface TriggerFoldBtnPropsType {
  className?: string;
  style?: React.CSSProperties;
  placementOffset?: any;
  state: boolean; // true: 高亮按钮, false: 默认态按钮
  onClick: Function | null;
  foldBubble?: string;
  unFoldBubble?: string;
  isVisibleBubble?: boolean;
  contentText?: string;
}

const DEFAULT_PROPS: TriggerFoldBtnPropsType = {
  className: '',
  style: {},
  placementOffset: undefined,
  state: false,
  onClick: null,
  foldBubble: 'Expand',
  unFoldBubble: 'Fold',
  isVisibleBubble: false,
  contentText: '',
};

function TriggerFoldBtn(props: TriggerFoldBtnPropsType) {
  const {
    className,
    style,
    placementOffset,
    state,
    onClick,
    foldBubble,
    unFoldBubble,
    isVisibleBubble,
    contentText,
  } = props;

  const [flag, setFlag] = useState<boolean>(false);

  const bubbleCon = useMemo(() => {
    return isVisibleBubble ? (flag ? unFoldBubble : foldBubble) : undefined;
  }, [isVisibleBubble, flag]);
  
  useEffect(() => {
    setFlag(state);
  }, [state]);

  return (
    <InfoBubble
      className="globalpedia-modal-font14"
      placementOffset={placementOffset}
      customBubbleContent={bubbleCon}
      DomOrText={
        <div
          className={classNames({
            'dbg-trigger-foldbtn': true,
            [className as string]: !!className,
            'light-icon': flag,
            'default-icon': !flag,
          })}
          style={style}
          onClick={(e) => {
            e.preventDefault();
            e.stopPropagation();
            setFlag(!flag);
            onClick?.();
          }}
        >
          <SvgIcon
            className="dbg-trigger-foldbtn-icon"
            type={flag ? 'open-eyes' : 'eyes-closed'}
          />
          <div className="dbg-trigger-foldbtn-text">{contentText}</div>
          {/* <Jumper
            direction="leftright"
            noBordered={false}
          /> */}
        </div>
      }
    />
  );
}

TriggerFoldBtn.defaultProps = DEFAULT_PROPS;

export default memo(TriggerFoldBtn);
